import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of, take } from 'rxjs';
import { PageUtils } from '../common/page.utils';
import { ErrorMessages } from '../constants/error-messages';
import { AssessApiService } from '../services/assess-api.service';
import { setAssessment } from '../store/actions/assessment.actions';
import { AssessmentPageState } from '../store/models/assessment-models';
import { LoggingService } from '../services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentGuardV2 implements CanActivate {
  constructor(
    private readonly assessApiService: AssessApiService,
    private readonly pageUtils: PageUtils,
    private readonly store: Store<AssessmentPageState>,
    private readonly logger: LoggingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routeParams = this.pageUtils.getRoutePathParameters(route);

    return this.assessApiService
      .getInvitation(routeParams.orgCode, routeParams.campaignCode, routeParams.invitationCode)
      .pipe(
        take(1),
        map((assessment) => {
          if (assessment != null && !Number.isNaN(assessment.assessmentId) && assessment.assessmentId > 0) {
            this.store.dispatch(setAssessment({ assessmentId: assessment.assessmentId }));
            return true;
          } else {
            this.pageUtils.navigateToErrorPage(ErrorMessages.assessmentNotFound);
            return false;
          }
        }),
        catchError((err: HttpErrorResponse) => {
          this.logger.logException(err, 3);
          console.log('Error in retrieving data for the assessment details provided: \n', err);

          if (err.status == 400) {
            this.pageUtils.navigateToErrorPage(
              `Error in opening assessment: ${err.error.error} Please contact your provider.`,
            );
          } else {
            this.pageUtils.navigateToErrorPage(ErrorMessages.assessmentRequestError);
          }

          return of(false);
        }),
      );
  }
}
